import config from '@/config'
const {name}=config


/**
 * 设置浏览器的title
 */
export const setTitle=(item)=>{
    let title="";
    if(item.meta && item.meta.name){
        title=item.meta.name
    } else title=item.name
    window.document.title = `${title} - ${name} `;
}


/**
 * 生成hash值
 * 默认长度24位
 * @param {*} hashLength 
 */
export function createHash(hashLength){
    return Array.from(Array(Number(hashLength) || 24), () => Math.floor(Math.random() * 36).toString(36)).join('');
}



// WEBPACK FOOTER //
// ./src/utils/curren.js